// Footer.js
import React from "react";
import { Card, Container } from "react-bootstrap";
import { SiFacebook, SiGithub, SiInstagram, SiLinkedin, SiLinktree, SiMedium } from "react-icons/si";
import './Footer.css'; // Ensure the CSS file is in the same directory as your component

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <Container>
          <Card className="footer-card">
            <Card.Body>
             
                <Card.Text>
       <p>Concept and programming by <a target="_blank" rel="noreferrer" href="https://marlonbarrios.github.io/"> Marlon Barrios Solano</a> </p> 
      
       <p> <a target="_blank" rel="noreferrer" href="https://linktr.ee/marlonbarriososolano"> <SiLinktree /></a>
        <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/marlon-barrios-solano-98599b205/"> <SiLinkedin /></a>
       <a target="_blank" rel="noreferrer" href="https://www.instagram.com/marlonbarriossolano/"> <SiInstagram /></a>
       <a target="_blank" rel="noreferrer" href="https://www.facebook.com/marlonbarriossolano"> <SiFacebook /></a>
       <a target="_blank" rel="noreferrer" href="https://github.com/marlonbarrios"> <SiGithub /></a>
       <a target="_blank" rel="noreferrer" href="https://medium.com/@marlon_21867"> <SiMedium/></a>

       </p>  
      
         
                <p> Developed during an Artistic Residence <a target="_blank" rel="noreferrer" href="https://radiona.org/marlon-barrios-solano-artist-in-residence-radiona/"> @Radiona, Art and Technlogy Center in Zagreb, Croatia.</a></p>
              </Card.Text>
            </Card.Body>
          </Card>
        </Container>
      </div>
    );
  }
}

export default Footer;